import { render } from "./PanelLink.vue?vue&type=template&id=29df9486"
import script from "./PanelLink.vue?vue&type=script&lang=js"
export * from "./PanelLink.vue?vue&type=script&lang=js"

import "./PanelLink.vue?vue&type=style&index=0&id=29df9486&lang=css"
script.render = render

export default script